import { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { EmptyState } from '../components/ui/EmptyState';
import { useAuthStore } from '../store/authStore';
import { loadOrderConfirmation } from './checkout/checkoutStorage';
import { OrderSuccessScreen } from './checkout/OrderSuccessScreen';

export function OrderConfirmedPage() {
  const { id } = useParams<{ id: string }>();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const orderId = Number(id);
  const isValidId = Number.isInteger(orderId) && orderId > 0;
  const confirmation = useMemo(() => (isValidId ? loadOrderConfirmation(orderId) : null), [isValidId, orderId]);

  if (!isValidId) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-8">
        <EmptyState
          title="Pedido não encontrado"
          action={
            <Link to="/">
              <Button>Voltar para a loja</Button>
            </Link>
          }
        />
      </div>
    );
  }

  return <OrderSuccessScreen orderId={orderId} confirmation={confirmation} isAuthenticated={isAuthenticated} />;
}
